import React, { useState, useEffect } from "react";
import { producaov2 } from "../../../../services/apis";
// import Dropzone from '../../../components/Admin/Dropzone';
import { toast } from "react-toastify";
import Menu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Container,
  SearchBarBox,
  SearchInput,
  SearchButton,
  TableHeader,
  DataBox,
  Modulo,
  NameModulo,
  Licao,
  NameLicao,
} from "./styles";
import "react-toastify/dist/ReactToastify.css";
import ReactHtmlParser from "react-html-parser";
import { FaSearch } from "react-icons/fa";
import { isAuthAdmin } from "../../../../services/auth";

toast.configure();
const AnalyticCursos = () => {
  const [listaProgresso, setListaProgresso] = useState([]);

  const [totalAlunos, setTotalAlunos] = useState();
  const [totalModulos, setTotalModulos] = useState();
  const [totalLicoes, setTotalLicoes] = useState();
  const [totalAlunosValidos, setTotalAlunosValidos] = useState();

  const [cursoPesquisado, setCursoPesquisado] = useState();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const getAnalytic = async () => {
    setLoading(true);

    producaov2
      .get(`/admin/analyitc/progresso/${cursoPesquisado}`)
      .then(({ data }) => {
        if (
          data.estadoProgresso.length === 0 &&
          data.numeroAlunos === 0 &&
          data.numeroModulos === 0 &&
          data.numeroLicoes === 0
        ) {
          alert("Curso não existe");

          setListaProgresso([]);

          setTotalAlunos(0);
          setTotalAlunosValidos(0);
          setTotalModulos(0);
          setTotalLicoes(0);
          return;
        }
        let logs = { local: "analytic/cursos", texto: `listou os cursos` };
        producaov2.post("system_logs", { acao: JSON.stringify(logs) });
        setListaProgresso(data.estadoProgresso);

        setTotalAlunos(data.numeroAlunos);
        setTotalModulos(data.numeroModulos);
        setTotalLicoes(data.numeroLicoes);
        setTotalAlunosValidos(data.numeroAlunosValidos);
      });

    setLoading(false);
  };

  return (
    <>
      <Menu />
      <Container>
        <SearchBarBox>
          <SearchInput
            placeholder={"Pesquise pelo id do curso"}
            onChange={(e) => setCursoPesquisado(e.target.value)}
            onKeyUp={(e) => (e.key === "Enter" ? getAnalytic() : null)}
            type={"number"}
            value={cursoPesquisado || ""}
          />
          <SearchButton onClick={() => getAnalytic()}>
            {" "}
            <FaSearch />{" "}
          </SearchButton>
        </SearchBarBox>
        <TableHeader>
          <div>
            {" "}
            Total Alunos Geral: <b>{totalAlunos}</b>{" "}
          </div>
          <div>
            {" "}
            Total Alunos Válidos: <b>{totalAlunosValidos}</b>{" "}
          </div>
          <div>
            {" "}
            Total Modulos: <b>{totalModulos}</b>{" "}
          </div>
          <div>
            {" "}
            Total Lições: <b>{totalLicoes}</b>{" "}
          </div>
        </TableHeader>
        <DataBox>
          {loading ? (
            <h2> Loading ...</h2>
          ) : listaProgresso.length <= 1 ? (
            <h2> Procure por um ID de curso válido no input acima </h2>
          ) : (
            listaProgresso.map((modulo) => (
              <Modulo>
                <NameModulo> {ReactHtmlParser(modulo.titulo)} </NameModulo>
                {modulo.licao.map((licao) => (
                  <Licao>
                    <NameLicao> {ReactHtmlParser(licao.titulo)} </NameLicao>
                    <b> {licao.totalEstudantes} </b>
                    <b>
                      {" "}
                      {(
                        (licao.totalEstudantes * 100) /
                        totalAlunosValidos
                      ).toFixed(3)}
                      %{" "}
                    </b>
                  </Licao>
                ))}
              </Modulo>
            ))
          )}
        </DataBox>
      </Container>
    </>
  );
};

export default AnalyticCursos;
